import { render } from "./Yoy.vue?vue&type=template&id=aa0f97ae"
import script from "./Yoy.vue?vue&type=script&lang=js"
export * from "./Yoy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__